import { createFileRoute } from '@tanstack/react-router';

import { ProductSheet } from '../../pages/product-sheet/ProductSheet';

export const Route = createFileRoute('/_auth/product-sheet/$productId')({
  component: ProductSheet,
});
